export const ADD_PARTICIPANTS_INVITES = "ADD_PARTICIPANTS_INVITES"
export const EDIT_PARTICIPANTS_INVITES = "EDIT_PARTICIPANTS_INVITES"
export const LIST_PARTICIPANTS_INVITES = "LIST_PARTICIPANTS_INVITES"
export const VIEW_PARTICIPANTS_INVITES = "VIEW_PARTICIPANTS_INVITES"
export const DELETE_PARTICIPANTS_INVITES = "DELETE_PARTICIPANTS_INVITES"

// Text
export const ADD_PARTICIPANTS_INVITES_TEXT = "ADD_PARTICIPANTS_INVITES_TEXT"
export const EDIT_PARTICIPANTS_INVITES_TEXT = "EDIT_PARTICIPANTS_INVITES_TEXT"
export const LIST_PARTICIPANTS_INVITES_TEXT = "LIST_PARTICIPANTS_INVITES_TEXT"
export const VIEW_PARTICIPANTS_INVITES_TEXT = "VIEW_PARTICIPANTS_INVITES_TEXT"
export const DELETE_PARTICIPANTS_INVITES_TEXT = "DELETE_PARTICIPANTS_INVITES_TEXT"

export const PARTICIPANTS_INVITES_SUCCESS = "PARTICIPANTS_INVITES_SUCCESS"
export const PARTICIPANTS_INVITES_ERROR = "PARTICIPANTS_INVITES_ERROR"

